module.exports = __webpack_public_path__ + "templates/rrss-icons.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/templates/rrss-icons.html
// module id = 5V9t
// module chunks = 1